// generated from 850 samples

import { z } from "zod";
import { messageGetBaseSchema } from "./messageGetBaseSchema";

export const featureFlagExperimentMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("featureFlagExperiment"),
  // feature flag experiments don't have traditional previews; accept any shape
  // the server returns to avoid validation failures on this irrelevant field
  preview_snippet: z.any(),
  feature_flag_is_enabled: z.boolean().nullable().optional(),
  feature_flag_properties: z.string().nullable().optional(),
  link_template_ids: z.array(z.string()).nullable(),
  optimal_send_percentage: z.int().min(0).max(100).nullable().optional(),
  parent_rollout_id: z.string().nullable().optional(),
});
